import { getDeviceId } from '@/auth'
import CONSTANTS from '@/constants'
import store from '@/store'
import mixin from "@/mixin"
// const DeviceIdKey = 'Device-Id'

const state = {
    token: null,
    deviceId: getDeviceId(),
    offer: null,
    answer: null,
    offer_socket_id: null,
    answer_socket_id: null,
    offer_accept: null,
    localStream: null,
    startTime: null,
    answerTime: null,
    statsReportFrom: null,
    statsReportTo: null,
    candidateUserFrom: null,
    candidateUserTo: null,
    isFinish: false,
    isSendCall: false,
    isSetBlur: false,
    peerConnection: null,
    sendOfferStatus: CONSTANTS.CALL_RECIEVE_OFFER,
    showCallingStatus: true,
    agency_id: 0,
    u_id: 0,
    r_id: 0,
    iceCandidateData: '',
    isAudioCall: false,
    countTime: null,
    pointSetting: null,
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_DEVICE_ID: (state, id) => {
        state.deviceId = id
    },
    SET_OFFER: (state, offer) => {
        state.offer = offer
    },
    SET_OFFER_ACCEPT: (state, offer) => {
        state.offer_accept = offer
    },
    
}

const actions = {
    async initPeerConnection({ commit }, data) {
        state.u_id = store.state.user.userDetail.id;
        state.agency_id = store.state.user.userDetail.agency_id;
        // if (state.r_id == 0) {
        //     state.r_id = parseInt(new URL(location.href).searchParams.get('user_id'));
        // }

        const configuration = {
            iceServers: [
               { urls: 'stun:stun.l.google.com:19302' },
               { urls: 'stun:stun.services.mozilla.com' },
               { urls: 'stun:stun.anyfirewall.com:3478' },
               { urls: 'turn:34.84.215.184:3480', credential: 'wido1234', username: 'widosoft' },
            ]
        };
        // const configuration = {};

        state.peerConnection = new RTCPeerConnection(configuration);
    },

    setupPeerEvent() {
        state.peerConnection.addEventListener('icecandidate', e => {
            state.isLocalSentCandidate = true;
            // Send candidate to remote
            const d = new Date();
            if (e.candidate) {
                this.dispatch('socket/sendCandidate', {
                    time: d.getTime(),
                    u_id: state.u_id,
                    r_id: state.r_id,
                    candidate: e.candidate,
                }).then((data) => {
                    // console.log('Candidate was sent to remote:::', data);
                }).catch((err) => {
                    console.log(err);
                });
            }

        });

        state.peerConnection.addEventListener('iceconnectionstatechange', e =>{
            this.dispatch('call/onIceStateChange', {
                device: state.peerConnection,
                event: e
            });
        });

        state.peerConnection.addEventListener('track', async (e) => {
            this.dispatch('call/gotRemoteStream', e)
        });
    },

    async doCall() {
        state.isSendCall = true;

        function hasUserMedia() {
            //check if the browser supports the WebRTC 
            return !!(navigator.mediaDevices.getUserMedia);
        }

        if (hasUserMedia()) {
            // Enabling video and audio channels
            // console.log('Requesting local stream');
            const stream = await navigator.mediaDevices.getUserMedia({video: this.isAudioCall ? false : { width: 1280, height: 720 }, audio: true});
            // console.log('Received local stream');

            state.localStream = stream;

            if (!this.isAudioCall) {
                // var video = document.querySelector('video');
                var video = document.getElementById('my_video_call');

                video.setAttribute('autoplay', '');
                // video.setAttribute('muted', true);
                video.setAttribute('playsinline', '');
                // video.autoplay = true;
                video.muted = true;
                // Inserting our stream to the video tag
                video.srcObject = stream;
                // console.log('Video was opened');
            }

            // console.log('Starting call');

            stream.getTracks().forEach(track => state.peerConnection.addTrack(track, stream));

            let param = {
                r_id: state.r_id,
                chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
                supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
                keijiban_id: '',
                caller: {
                    name: store.state.user.userDetail.display_name,
                    avatar_url: store.state.user.userDetail.avatar_url,
                    total_age: store.state.user.userDetail.age + '歳',
                    living_area: store.state.user.userDetail.living_area,
                    sex: store.state.user.userDetail.sex
                },
            };
            
            await this.dispatch('socket/clientChatCall', param).then((data) => {
            }).catch((err) => {
                console.log(err);
            });

            const date = new Date();
            state.startTime = date.getTime();
            this.dispatch('call/clientCallProcess', {
                type: CONSTANTS.CALL_TYPE_PREFLIGHT,
                chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
                supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
                // read_status: CONSTANTS.MSG_STATUS_READ,
                // offer: offer,
                // answer: '',
                time: state.startTime,
                start_time: state.startTime
            });

        } else {
            alert("WebRTC is not supported");
        }
    },

    async acceptCall() {
        // state.isSendCall = true;

        function hasUserMedia() { 
            //check if the browser supports the WebRTC 
            return !!(navigator.mediaDevices.getUserMedia);
        }
    
        if (hasUserMedia()) {
            // Enabling video and audio channels
            // console.log('Requesting local stream');
            const stream = await navigator.mediaDevices.getUserMedia({video: this.isAudioCall ? false : { width: 1280, height: 720 }, audio: true});
            // console.log('Received local stream');
    
            // var video = document.querySelector('video');
            // document.getElementById('show_remote_video').style.display = 'block';
            // var video = document.getElementById('remote_video_call');
    
            // video.setAttribute('autoplay', '');
            // // video.setAttribute('muted', true);
            // video.setAttribute('playsinline', '');
            // video.muted = true;
            // // Inserting our stream to the video tag
            // video.srcObject = stream;
            state.localStream = stream;
            // console.log('Video was opened');
    
            // console.log('Starting call');

            try {
                stream.getTracks().forEach(track => state.peerConnection.addTrack(track, stream));
                // console.log('Added local stream to local device');

                // console.log('local device createOffer start');
                const offer = await state.peerConnection.createOffer();
                await this.dispatch('call/onCreateOfferSuccess', offer);
            } catch (e) {
                await this.dispatch('call/onCreateSessionDescriptionError', e);
            }
    
        } else {
            alert("WebRTC is not supported");
        }
    },

    // async onIceCandidate({commit}, params) {
    //     try {
    //         this.dispatch('call/getOtherDevice', params.device).then(data => {
    //             data.addIceCandidate(params.event.candidate);
    //         });

    //         // bbb.addIceCandidate(params.event.candidate);
    //         // await (this.dispatch('call/getOtherDevice', params.device).addIceCandidate(params.event.candidate));
    //         this.dispatch('call/onAddIceCandidateSuccess', params.device);
    //     } catch (e) {
    //         this.dispatch('call/onAddIceCandidateError', {
    //             device: params.device,
    //             error: e
    //         });
    //     }
    //     console.log(`${this.dispatch('call/getName', params.device)} ICE candidate:\n${params.event.candidate ? params.event.candidate.candidate : '(null)'}`);
    // },

    getOtherDevice({commit}, device) {
        return (device === state.localDevice) ? state.remoteDevice : state.localDevice;
    },
    
    getName({commit}, device) {
        return (device === state.localDevice) ? state.localDevice : state.remoteDevice;
    },

    onAddIceCandidateSuccess({commit}, device) {
        console.log(`${this.dispatch('call/getName', device)} addIceCandidate success`);
    },

    onAddIceCandidateError({commit}, params) {
        console.log(`${this.dispatch('call/getName', params.device)} failed to add ICE Candidate: ${params.error.toString()}`);
    },

    onIceStateChange({commit}, params) {
        if (params.device) {
            console.log(`${this.dispatch('call/getName', params.device)} ICE state: ${params.device.iceConnectionState}`);
            // console.log('ICE state change event: ', params.event);
        }
    },

    gotRemoteStream({commit}, e) {
        if (state.isSendCall) {
            // let remoteVideo = document.getElementById('remote_video');
            document.getElementById('start_call').style.display = 'none';
            document.getElementById('show_remote_video').style.display = 'block';
            var my_video = document.getElementById('my_video_call');
            var remote_video = document.getElementById('remote_video_call');

            if (my_video.srcObject !== e.streams[0]) {

                my_video.pause();
                my_video.srcObject = e.streams[0];
                my_video.muted = false;
                my_video.play();

                remote_video.setAttribute('autoplay', true);
                // remote_video.setAttribute('muted', '');
                remote_video.setAttribute('playsinline', true);

                remote_video.srcObject = state.localStream;
                remote_video.muted = true;
                remote_video.play();

                document.getElementById('calling_page').style.display = 'block';

                // video.onloadedmetadata = function(e) {
                //     video.play();
                //   };

                // console.log('pc2 received remote stream');
            }

        } else {
            // let remoteVideo = document.getElementById('remote_video');
            document.getElementById('coming_call_page').style.display = 'none';
            document.getElementById('show_remote_video').style.display = 'block';
            document.getElementById('show_my_video').style.display = 'block';

            var my_video = document.getElementById('my_video_call');
            var remote_video = document.getElementById('remote_video_call');

            if (my_video.srcObject !== e.streams[0]) {

                my_video.setAttribute('autoplay', true);
                my_video.setAttribute('muted', '');
                my_video.setAttribute('playsinline', true);

                my_video.srcObject = e.streams[0];
                my_video.play();

                remote_video.setAttribute('autoplay', true);
                remote_video.setAttribute('muted', '');
                remote_video.setAttribute('playsinline', true);

                // remote_video.pause();
                remote_video.srcObject = state.localStream;
                remote_video.muted = true;
                remote_video.play();

                document.getElementById('calling_page').style.display = 'block';

                // video.onloadedmetadata = function(e) {
                //     video.play();
                //   };

                // console.log('pc2 received remote stream');
            }
        }

        let style_display_audio = 'block';
        if (this.isAudioCall) {
            style_display_audio = 'none';
        }

        document.getElementById('blur_slide').style.display = style_display_audio;
        document.getElementById('call_off_camera').style.display = style_display_audio;

        this.dispatch('call/showCountTime');

    },

    async onCreateOfferSuccess({commit}, offer) {
        // console.log(`Offer from pc1\n${offer.sdp}`);
        // console.log('pc1 setLocalDescription start');

        state.offer = offer;

        try {
            await state.peerConnection.setLocalDescription(offer);
            this.dispatch('call/onSetLocalSuccess', state.peerConnection);
        } catch (e) {
            this.dispatch('call/onSetSessionDescriptionError', e);
        }

        state.sendOfferStatus = CONSTANTS.CALL_SENT_OFFER;

        const date = new Date();
        state.startTime = date.getTime();
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_CALLING,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ,
            offer: offer,
            answer: '',
            time: state.startTime,
            start_time: state.startTime
        });
    },

    async clientCallProcess({commit}, params) {
        const date = new Date();
        let param = {
            time: date.getTime(),
            type: params.type,
            msg_data: {
                agency_id: state.agency_id,
                msg_id: state.u_id + '-' + state.r_id + '-' + params.time,
                msg_uuid: '',
                r_id: state.r_id,
                u_id: state.u_id,
                msg: '',
                type: CONSTANTS.CALL_TYPE_CALL,
                time: params.time,
                chat_center: params.chat_center,
                keijiban_id: '',
                supports_video: params.supports_video,
                param: {
                    caller: {
                        // TODO fix this: receive caller from socket and set
                        name: store.state.user.userDetail.display_name,
                        avatar_url: store.state.user.userDetail.avatar_url,
                        total_age: store.state.user.userDetail.age + '歳',
                        living_area: store.state.user.userDetail.living_area,
                        sex: store.state.user.userDetail.sex
                    },
                    start_time: params.start_time,
                    offer: params.offer
                }
            }
        };

        if (state.offer_socket_id) {
            param.msg_data.param.offer_socket_id = state.offer_socket_id;
        }

        if (state.answer_socket_id) {
            param.msg_data.param.answer_socket_id = state.answer_socket_id;
        }

        if (state.answerTime) {
            param.msg_data.param.answer_time = state.answerTime;
        }

        if (params.type != CONSTANTS.CALL_TYPE_CALLING) {
            param.msg_data.param.answer = params.answer;
        }

        if (params.type == CONSTANTS.CALL_TYPE_ACCEPT) {
            // console.log('accept call');

        } else if (params.type == CONSTANTS.CALL_TYPE_SIGMABLUR) {
            param.msg_data.sigma_blur = params.sigma_blur;
        }

        if (params.type == CONSTANTS.CALL_TYPE_REPORT) {
            param.candidate_info = {};
            // Get candidate info
            await this.dispatch('call/candidateInfo', { type: params.type }).then((data) => {
                param.candidate_info.stats_report = data.stats_report;
                if (state.isFinish) {
                    param.candidate_info.candidate_user_from = data.candidate_user;

                } else {
                    param.candidate_info.candidate_user_to = data.candidate_user;
                }

            }).catch((err) => {
                console.log(err);
            });

        } else if (params.type == CONSTANTS.CALL_TYPE_DONE) {
            param.msg_data.param.report_user_From = {
                stats_report: state.statsReportFrom,
                candidate_user_from: state.candidateUserFrom,
            };

            param.msg_data.param.report_user_To = {
                stats_report: state.statsReportTo,
                candidate_user_to: state.candidateUserTo,
            };

        }

        await this.dispatch('socket/clientCallProcess', param).then((data) => {
        }).catch((err) => {
            console.log(err);
        });
    },

    serverCallIsProcess({commit}, data) {
        if (data.type == CONSTANTS.CALL_TYPE_PREFLIGHT) {
            this.dispatch('call/showCallingScreen', data);

        } else if (data.type == CONSTANTS.CALL_TYPE_CALLING) {
            // Set send offer status to local device
            if (state.isSendCall) {
                state.offer = data.msg_data.param.offer;

                // Set offer to local
                this.dispatch('call/setOffer', state.offer);
            }

            if (data.msg_data.chat_center == CONSTANTS.CHAT_CENTER_VOICE) {
                this.isAudioCall = true;
            }

            state.offer_socket_id = data.msg_data.param.offer_socket_id;

        } else if (data.type == CONSTANTS.CALL_TYPE_ACCEPT) {
            if (!state.isSendCall) {
                state.answer = data.msg_data.param.answer;
                this.dispatch('call/setAnswer', state.answer);
                document.getElementById('calling_page').style.display = 'block';
            }

            state.answerTime = data.msg_data.param.answer_time;
            state.answer_socket_id = data.msg_data.param.answer_socket_id;

        } else if (data.type == CONSTANTS.CALL_TYPE_CANCEL) {
            this.dispatch('call/execStopCall', CONSTANTS.CALL_TYPE_CANCEL);

        } else if (data.type == CONSTANTS.CALL_TYPE_DENIED) {
            this.dispatch('call/execStopCall', CONSTANTS.CALL_TYPE_DENIED);

        } else if (data.type == CONSTANTS.CALL_TYPE_SIGMABLUR) {
            this.dispatch('call/setBlurVideo', data.msg_data.sigma_blur);
        }

        if (data.type == CONSTANTS.CALL_TYPE_REPORT) {
            if (!state.isFinish && state.sendOfferStatus != CONSTANTS.CALL_SENT_REPORT) {
                this.dispatch('call/sendReport');

            } else if (state.sendOfferStatus == CONSTANTS.CALL_SENT_REPORT) {
                state.sendOfferStatus = CONSTANTS.CALL_FINISH;

                state.statsReportFrom = data.candidate_info.stats_report;
                state.candidateUserFrom = data.candidate_info.candidate_user_from;

            } else if (state.sendOfferStatus == CONSTANTS.CALL_FINISH) {
                state.statsReportTo = data.candidate_info.stats_report;
                state.candidateUserTo = data.candidate_info.candidate_user_to;

                this.dispatch('call/doneCall', data);
            }

            // if (state.isSendCall) {
            //     this.dispatch('call/finishCall');

            // } else if (!state.isSendCall && !state.isFinish) {
            //     state.isFinish = true;
            //     this.dispatch('call/finishCall');

            // } else if (!state.isSendCall && state.isFinish) {
            //     this.dispatch('call/doneCall', data);
            // }

        } else if (data.type == CONSTANTS.CALL_TYPE_DONE) {
            this.dispatch('call/execCallDone');

        }
    },

    doneCall({commit}, data) {
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_DONE,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ, // TODO change this
            offer: state.offer,
            answer: state.answer,
            time: state.startTime,
            start_time: state.startTime
        });
    },

    async candidateInfo({commit}, params) {
        let return_data = {};
        if (params.type == CONSTANTS.CALL_TYPE_REPORT) {
            await state.peerConnection.getStats(null).then(res => {
                res.forEach(report => {
                    if (report.type == 'candidate-pair') {
                        return_data.stats_report = report;

                    } else if (report.type == 'local-candidate') {
                        return_data.candidate_user = report;
                    }
                });
            });

        } else if (params.type == CONSTANTS.CALL_TYPE_DONE) {
            await state.peerConnection.getStats(null).then(res => {
                res.forEach(report => {
                    if (report.type == 'candidate-pair') {
                        return_data.stats_report = report;
                    }
    
                    if (report.type == 'remote-candidate') {
                        return_data.candidate_user_to = report;
                    }
                });
            });            

        }

        return return_data;

    },

    showCallingScreen({commit}, data) {
        if (!state.isSendCall) {
            state.r_id = data.msg_data.u_id;
            state.startTime = data.msg_data.param.start_time;

            document.getElementById('start_call_page').style.display = 'block';
            document.getElementById('call_pages').style.display = 'block';
            document.getElementById('coming_call_page').style.display = 'block';
            document.getElementsByClassName('btn_close_start_call')[0].style.display = 'none';

            document.getElementById('start_call_calling').getElementsByTagName('p')[0].textContent = data.msg_data.param.caller.name + ' is calling';
            document.getElementById('call_avatar').src = mixin.methods.getImageUrl(data.msg_data.param.caller.avatar_url);
        }
    },

    execStopCall({commit}, callType) {
        if (this.isAudioCall) {
            this.isAudioCall = false;
        }

        if (callType == CONSTANTS.CALL_TYPE_CANCEL && state.isSendCall) {
            this.dispatch('call/stopLocalStream');

        } else if (callType == CONSTANTS.CALL_TYPE_DENIED && state.isSendCall) {
            // this.dispatch('call/stopLocalStream');
        }

        this.dispatch('call/stopConnection');
    },

    stopLocalStream() {
        state.localStream.getTracks().forEach(function(track) {
            track.stop();
        });
    },

    execCallDone() {
        if (this.isAudioCall) {
            this.isAudioCall = false;
        }

        if (this.countTime) {
            clearInterval(this.countTime);
            this.countTime = null;
            document.getElementById('call_count_time').innerHTML =  '00:00';
        }
        // if (state.isSendCall) {
        //     this.dispatch('call/stopLocalStream');
        // }
        this.dispatch('call/stopLocalStream');

        this.dispatch('call/stopConnection');
    },

    stopConnection() {
        if (state.peerConnection) {
            state.peerConnection.close();
            state.peerConnection = null;
        }

        this.dispatch('call/noShowCallPages');
        this.dispatch('call/resetCallingStatus');
    },

    onCreateSessionDescriptionError({commit}, error) {
        console.log(`Failed to create session description: ${error.toString()}`);
    },

    onSetSessionDescriptionError({commit}, error) {
        console.log(`Failed to set session description: ${error.toString()}`);
    },

    onSetLocalSuccess({commit}, device) {
        console.log(`${this.dispatch('call/getName', device)} setLocalDescription complete`);
    },

    onSetRemoteSuccess({commit}, device) {
        console.log(`${this.dispatch('call/getName', device)} setRemoteDescription complete`);
    },

    async onCreateAnswerSuccess({commit}, answer) {
        // console.log(`Answer from remote device:\n${answer.sdp}`);
        // console.log('remote device setLocalDescription start');

        state.answer = answer;

        try {
            await state.peerConnection.setLocalDescription(answer);
            this.dispatch('call/onSetLocalSuccess', state.remoteDevice);
        } catch (e) {
            this.dispatch('call/onSetSessionDescriptionError', e);
        }

        state.sendOfferStatus = CONSTANTS.CALL_SENT_ANSWER;

        // this.dispatch('call/getClientCallProcessParams', { desc: desc }).then((data) => {
        //     this.dispatch('call/clientCallProcess', data);
        // })
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_ACCEPT,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ,
            offer: state.offer,
            answer: answer,
            time: state.startTime,
            start_time: state.startTime
        });
    },

    async setCandidate({ commit }, data) {
        // let device = null;
        try {
            // if (state.isLocalSentCandidate) {
            //     device = state.remoteDevice;
            // } else if (state.isRemoteSentCandidate) {
            //     device = state.localDevice;
            // }


            if (state.iceCandidateData == '') {
                state.iceCandidateData = data
            } else {
                // if (data != '') {
                //     state.iceCandidateData = data.candidate
                // }

                if (state.peerConnection) {
                    await state.peerConnection.addIceCandidate(data.candidate);
                }
            }

            // if (state.peerConnection) {
            //     await state.peerConnection.addIceCandidate(state.iceCandidateData);
            // }
            
        } catch (e) {
            this.dispatch('call/onAddIceCandidateError', {
                device: state.peerConnection,
                error: e
            });
        }
        console.log(`${this.dispatch('call/getName', state.peerConnection)} ICE candidate:\n${data.candidate ? data.candidate.candidate : '(null)'}`);

    },

    demoCall({ commit }, data) {
        // this.offer = data.offer;

        commit('SET_OFFER', data.offer)

        // Show poup call is coming
        document.getElementById('btn_accept_call').style.display = 'block';
    },

    async setOffer({ commit }, offer) {
        try {
            await state.peerConnection.setRemoteDescription(offer);
            this.dispatch('call/onSetRemoteSuccess', state.peerConnection);
        } catch (e) {
            this.dispatch('call/onSetSessionDescriptionError', e);
        }

        // Since the 'remote' side has no media stream we need
        // to pass in the right constraints in order for it to
        // accept the incoming offer of audio and video.
        try {
            const answer = await state.peerConnection.createAnswer();
            this.dispatch('call/onCreateAnswerSuccess', answer);
        } catch (e) {
            this.dispatch('call/onCreateSessionDescriptionError', e);
        }
    },

    async setAnswer({ commit }, answer) {
        // console.log('Local receive answer from remote');
        this.dispatch('call/setAnswerToLocal', answer);
    },

    async setAnswerToLocal({ commit }, answer) {
        // console.log('local device setRemoteDescription');
        // state.answer = answer;
        // this.dispatch('call/setupPeerEvent');
        try {
            await state.peerConnection.setRemoteDescription(answer);
            this.dispatch('call/onSetRemoteSuccess', state.localDevice);

            if (state.iceCandidateData != '') {
                this.dispatch('call/setCandidate', state.iceCandidateData);
            }
            // else {
            //     state.iceCandidateData = 'has data'; // pass random value
            // }
            
        } catch (e) {
            this.dispatch('call/onSetSessionDescriptionError', e);
        }
    },

    call_audio({ commit }, data) {
        state.r_id = data.r_id;
        state.pointSetting = data.pointSetting;
        // Show audio call screen
        document.getElementById('call_pages').style.display = 'block';
        document.getElementById('start_call_page').style.display = 'block';

        this.isAudioCall = true;
  
        // Do call
        this.dispatch('call/initPeerConnection');
        this.dispatch('call/doCall');
        this.dispatch('call/setupPeerEvent');
    },

    call_video({ commit }, data) {
        state.r_id = data.r_id;
        state.pointSetting = data.pointSetting;
        // call_avatar
        document.getElementById('call_pages').style.display = 'block';
        document.getElementById('start_call_page').style.display = 'block';
        document.getElementById('start_call_calling').getElementsByTagName('p')[0].textContent = 'calling ' + document.getElementById('chat').getElementsByTagName('header')[0].textContent
        document.getElementById('call_avatar').src = data.avatar_url

        // Show video call screen

        document.getElementById('show_my_video').style.display = 'block';

        // Do call
        // this.dispatch('socket/setupSocketCallEvent');
        this.dispatch('call/initPeerConnection');
        this.dispatch('call/doCall');
        this.dispatch('call/setupPeerEvent');
        
    },

    acceptComingCall({ commit }, data) {
        state.pointSetting = data.pointSetting;
        this.dispatch('call/initPeerConnection');
        this.dispatch('call/acceptCall');
        this.dispatch('call/setupPeerEvent');
    },

    cancelStartCall() {
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_CANCEL,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ, // TODO change this
            offer: '',
            answer: '',
            time: state.startTime,
            start_time: state.startTime
        });

        if (this.isAudioCall) {
            this.isAudioCall = false;
        }
    },

    denyComingCall() {
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_DENIED,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ, // TODO change this
            offer: state.offer,
            answer: state.answer,
            time: state.startTime,
            start_time: state.startTime
        });
    },

    finishCall() {
        state.isFinish = true;
        this.dispatch('call/sendReport');

        if (state.peerConnection) {
            state.peerConnection.close();
            state.peerConnection = null;
        }
    },

    sendReport() {
        state.sendOfferStatus = CONSTANTS.CALL_SENT_REPORT;
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_REPORT,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ, // TODO change this
            offer: state.offer,
            answer: state.answer,
            time: state.startTime,
            start_time: state.startTime
        });
    },

    resetCallingStatus() {
        state.sendOfferStatus = CONSTANTS.CALL_RECIEVE_OFFER;
        state.offer = null;
        state.answer = null;
        state.offer_socket_id  = null;
        state.answer_socket_id  = null;
        state.localStream = null;
        state.startTime = null;
        state.answerTime = null;
        state.statsReportFrom = null;
        state.statsReportTo = null;
        state.candidateUserFrom = null;
        state.candidateUserTo = null;
        state.isFinish = false;
        state.isSendCall = false;
        state.iceCandidateData = '';
    },

    noShowCallPages() {
        document.getElementById('call_pages').style.display = 'none';
        document.getElementById('show_my_video').style.display = 'none';
        document.getElementById('show_remote_video').style.display = 'none';
        document.getElementById('start_call_page').style.display = 'none';
        document.getElementById('coming_call_page').style.display = 'none';
        document.getElementById('calling_page').style.display = 'none';
        document.getElementById('call_count_time').style.display = 'none';

        document.getElementById('blur_slide').getElementsByTagName('input')[0].value = 0
        document.getElementById('my_video_call').style.filter = 'blur(0px)';
        document.getElementById('remote_video_call').style.filter = 'blur(0px)';
    },

    onOffCamera() {
        state.localStream.getVideoTracks().forEach(track => track.enabled = !track.enabled);
        let state_camera_text = document.getElementsByClassName('btn_call_off_camera')[0];
        if (state_camera_text.innerText == 'Off camera') {
            state_camera_text.innerText = 'On camera';
        } else {
            state_camera_text.innerText = 'Off camera';
        }
        
    },

    muteUnMuteAudio() {
        state.localStream.getAudioTracks().forEach(track => track.enabled = !track.enabled);
        let state_audio_text = document.getElementsByClassName('btn_call_mute')[0];
        if (state_audio_text.innerText == 'Mute') {
            state_audio_text.innerText = 'Un mute';
        } else {
            state_audio_text.innerText = 'Mute';
        }
    },

    blurVideo({ commit }, blurVal) {
        // state.sendOfferStatus = CONSTANTS.CALL_SENT_REPORT;
        this.dispatch('call/clientCallProcess', {
            type: CONSTANTS.CALL_TYPE_SIGMABLUR,
            chat_center: this.isAudioCall ? CONSTANTS.CHAT_CENTER_VOICE : CONSTANTS.CHAT_CENTER_VIDEO,
            supports_video: this.isAudioCall ? CONSTANTS.NOT_SUPPORTS_VIDEO : CONSTANTS.SUPPORTS_VIDEO,
            read_status: CONSTANTS.MSG_STATUS_READ, // TODO change this
            offer: state.offer,
            answer: state.answer,
            time: state.startTime,
            start_time: state.startTime,
            sigma_blur: blurVal,
        });

        this.isSetBlur = true;

        if (this.isSendCall) {
            document.getElementById('my_video_call').style.filter = 'blur(' + blurVal + 'px)';
        } else {
            document.getElementById('remote_video_call').style.filter = 'blur(' + blurVal + 'px)';
        }
    },

    setBlurVideo({ commit }, sigma_blur) {
        if (!this.isSetBlur) {
            document.getElementById('my_video_call').style.filter = 'blur(' + sigma_blur + 'px)';
        }

        this.isSetBlur = false;
    },

    showCountTime() {
        document.getElementById('call_count_time').style.display = 'block';

        let seconds = 0;
        let seconds_show = 0;
        let hours = 0;
        let hours_show = 0;
        if (!this.countTime) {
            this.countTime = setInterval(function() {
                seconds += 1;
            
                if (seconds > 59) {
                    seconds = 0;
                    hours += 1;
                }
                
                if (seconds < 10) {
                    seconds_show = '0' + seconds;
                } else {
                    seconds_show = seconds;
                }
    
                if (hours < 10) {
                    hours_show = '0' + hours;
                } else {
                    hours_show = hours;
                }

                document.getElementById('call_count_time').innerHTML =  hours_show + ":" + seconds_show;
            
            }, 1000);
        }
    },

    sendGift({ commit }, data) {
        this.dispatch('socket/sendGift', {
            gift_id: data.giftId,
            user_id: state.r_id
        })
    },

    serverChatReceive({ commit }, data) {
        if (data.type == CONSTANTS.MSG_RECEIVE_TYPE.GIFT) {
            let received_gift = document.getElementById('received_gift');
            received_gift.insertAdjacentHTML( 'beforeend', '<p id="gift_showed_call"><img src="' + mixin.methods.getImageUrl(getGift(data.param.gift_id).image_show) + '" /></p>' );

            setTimeout(function(){
                document.getElementById('gift_showed_call').remove();
            }, 1000);
        }

        function getGift(id) {
            if (!state.pointSetting) return
            let gift = state.pointSetting.gifts.result.filter((item) => {
                return parseInt(item.id) === parseInt(id);
            });
            return gift[0];
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}